export const subjectListTitles = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "Subject name", colWidth: "150px", key: "name" },
  { titleName: "Subject type", colWidth: "150px", key: "subject_type_title" },
];
